import ENDPOINTS from '../api/endPoints';
import type { CustomizationParams, CustomizationFiles } from '../types/customization.types';

// Mapping from CustomizationParams keys to API query param names
const PARAM_MAP: Record<string, string> = {
  accountId: 'account_id',
  frameFabricUrl: 'frame_fabric_url',
  backCushionFabricUrl: 'back_cushion_fabric_url',
  seatFabricUrl: 'seat_fabric_url',
  armrestFabricUrl: 'armrest_fabric_url',
  finishUrl: 'finish_url',
  pillowSize: 'pillow_size',
  pillowCount: 'pillow_count',
  pillowFabricUrl: 'pillow_fabric_url',
  nailheadSize: 'nailhead_size',
};

export function buildCustomizationPayload(
  params: CustomizationParams,
  files: CustomizationFiles
): { url: string; formData: FormData } {
  const url = new URL(ENDPOINTS.customizeFurniture);

  for (const [key, apiKey] of Object.entries(PARAM_MAP)) {
    const value = (params as Record<string, any>)[key];
    if (value != null && value !== '') {
      url.searchParams.set(apiKey, String(value));
    }
  }

  const formData = new FormData();

  for (const file of files.furnitureFiles) {
    formData.append('furniture_files', file, file.name);
  }

  if (files.pillowFile) {
    formData.append('pillow_file', files.pillowFile, files.pillowFile.name);
  }

  if (files.nailheadFile) {
    formData.append('nailhead_file', files.nailheadFile, files.nailheadFile.name);
  }

  return { url: url.toString(), formData };
}
